// Display helper: prefer admin-set label, fall back to hours derived from minutes.
export function formatDuration(tour) {
  if (!tour) return "";
  if (tour.duration_label && tour.duration_label.trim()) return tour.duration_label.trim();
  const m = Number(tour.duration_minutes || 0);
  if (!m) return "";
  const h = m / 60;
  if (Number.isInteger(h)) return `${h} hour${h === 1 ? "" : "s"}`;
  return `${h.toFixed(1)} hours`;
}
